import { AuroraBackground } from './componentes/aurora-background';
import { BarraProgresso } from './componentes/barra-progresso';
import { BotaoTopo } from './componentes/botao-topo';
import { Cabecalho } from './componentes/cabecalho';
import { Hero } from './componentes/hero';
import { AuditoriaGratuita } from './componentes/auditoria-gratuita';
import { ProvaNumerica } from './componentes/prova-numerica';
import { ComoFunciona } from './componentes/como-funciona';
import { RecursosBento } from './componentes/recursos-bento';
import { Documentos } from './componentes/documentos';
import { Seguranca } from './componentes/seguranca';
import { Planos } from './componentes/planos';
import { Faq } from './componentes/faq';
import { CtaFinal } from './componentes/cta-final';
import { Rodape } from './componentes/rodape';

/**
 * Landing de página única — cada seção vive em `componentes/`, esta função
 * só monta a ordem. Um único `<h1>`, dentro de `<Hero />`.
 */
export function App(): JSX.Element {
  return (
    <div className="relative min-h-screen">
      {/*
        `palco-fundo` e não `inset-0`: `inset: 0` prende o fundo à viewport de
        LAYOUT, e só o Safari do iPhone a redimensiona ao recolher/expandir a
        barra de endereço durante a rolagem — re-rasterizando os blobs
        borrados a cada frame da transição. Com altura em `100lvh` (a maior
        viewport possível), o palco nasce já no tamanho final e não mexe.
        Chrome/Firefox no iOS (mesmo WebKit) não redimensionam assim — foi o
        que isolou a causa: fluidos lá, travando só no Safari.
      */}
      <div aria-hidden className="palco-fundo pointer-events-none -z-10">
        <AuroraBackground />
      </div>

      <BarraProgresso />
      <Cabecalho />

      <main>
        <Hero />
        <AuditoriaGratuita />
        <ProvaNumerica />
        {/* A seção de dores saiu (corte do dono, 2026-09-03): repetia a tese
            que o herói acabou de dizer; a melhor frase migrou para o conduz
            de "Como funciona". */}
        <ComoFunciona />
        <RecursosBento />
        <Documentos />
        <Seguranca />
        <Planos />
        <Faq />
        <CtaFinal />
      </main>

      <Rodape />
      <BotaoTopo />
    </div>
  );
}
